<template>
  <div style="height: 100%">
    <div class="pageContainer">

      <div class="asideContainer" style="border-right: 4px solid whitesmoke;width: 54%">
        <div class="size" style="height: 29%">
          <el-row style="width: 100%;height: 100%">
            <div style="width: 70%;margin-left: 10px;height: 100%">
              <div style="font-size: 18px;width: 100%;background-color: #0a84ff;color: #FFFFFF;font-weight: bold">
                {{this.wujian_id+'-'+wujian_short_name}}</div>
              <div>
                <el-row>
                  <el-col :span="3">場所：</el-col>
                  <el-col :span="21">{{wujianInfoData.place}}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="3">建築主：</el-col>
                  <el-col :span="21">{{wujianInfoData.building_owner}}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="3">設计：</el-col>
                  <el-col :span="21">{{wujianInfoData.design}}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="3">施工：</el-col>
                  <el-col :span="21">{{wujianInfoData.construction}}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="3">用途：</el-col>
                  <el-col :span="21">{{wujianInfoData.purpose}}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="3">階数：</el-col>
                  <el-col :span="21">{{wujianInfoData.stratum}}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="4">延床面積：</el-col>
                  <el-col :span="8">{{wujianInfoData.extended_bed_area}}㎡</el-col>
                  <el-col :span="4">解体工期：</el-col>
                  <el-col :span="8">{{wujianInfoData.dismantling_start}}~{{wujianInfoData.dismantling_end}}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="4">建物高さ：</el-col>
                  <el-col :span="8">{{wujianInfoData.building_height}}m</el-col>
                  <el-col :span="4">建築工期：</el-col>
                  <el-col :span="8">{{wujianInfoData.building_start}}~{{wujianInfoData.building_end}}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="4">CW面積：</el-col>
                  <el-col :span="8">{{wujianInfoData.cw_area}}㎡</el-col>
                  <el-col :span="4">CW工期：</el-col>
                  <el-col :span="8">{{wujianInfoData.cw_start}}~{{wujianInfoData.cw_end}}</el-col>
                </el-row>
              </div>
            </div>
            <div style="width:25%;height:100%;margin-left: 10px">
              <el-image :src="wujianInfoData.frontViewUrl" :preview-src-list="[wujianInfoData.frontViewUrl]"
                        style="width: 100%;height: 100%;"
                        :initial-index="0" fit="cover" preview-teleported="true" />
            </div>
          </el-row>
        </div>
        <div class="size" style="height: 29%;">

          <div class="title">
            <el-row style="
              align-items: center;">
              <span>{{'物件计划&实绩'}}</span>
              <i class="dotClass" style="background: rgba(255 245 204);border: rgba(255 204 0) solid 1px "></i>
              <span style="margin-left:5px;font-size: 14px">加工计划</span>

              <i class="dotClass" style="background: rgba(255 204 0)"></i>
              <span style="margin-left:5px;font-size: 14px">加工实绩</span>

              <i class="dotClass" style="background: rgba(229 181 255);border: rgba(166 0 255) solid 1px "></i>
              <span style="margin-left:5px;font-size: 14px">涂装计划</span>

              <i class="dotClass" style="background: rgba(166 0 255)"></i>
              <span style="margin-left:5px;font-size: 14px">涂装实绩</span>

              <i class="dotClass" style="background: #DBFCC9;border: #94D82D solid 1px "></i>
              <span style="margin-left:5px;font-size: 14px">组立计划</span>

              <i class="dotClass" style="background: #94D82D"></i>
              <span style="margin-left:5px;font-size: 14px">组立实绩</span>

            </el-row>
          </div>
          <div style="width: 100%;height: 85%;">
            <el-table :data="planAchievementsData.floorData" border :key="tableKey" stripe style="width: 100%;"
                      :header-cell-style="{textAlign: 'center',fontSize:'15px'}"
                      :cell-style="{ textAlign: 'center', width: '100%',fontSize:'14px'}" height="100%" >
              <el-table-column prop="floor" label="楼层" min-width="20" fixed/>
              <el-table-column prop="advance_floor" label="先行楼层" width="100" fixed/>
              <el-table-column prop="weight" label="重量(KG)" min-width="56">
                <template v-slot="scope">
                  {{scope.row.weight.toLocaleString()}}
                </template>
              </el-table-column>
              <el-table-column prop="unit_num" label="单元数量" min-width="40" />
              <el-table-column prop="area" label="面积(㎡)" min-width="50" >
                <template v-slot="scope">
                  {{scope.row.area.toLocaleString()}}
                </template>
              </el-table-column>

              <el-table-column :label="planAchievementsData.dateList[index].years" v-for="(item,index) in planAchievementsData.dateList" :key="item.index">
                <el-table-column :label="item.monthList[index].day" v-for="(list,index) in item.monthList" :key="list.date">
                  <el-table-column :label="item.monthList[index].week" min-width="18">
                    <template v-slot="scope">
                      <div v-for="plannedActual in scope.row.planned_actual" :key="plannedActual.lot">
                        <div v-if="item.monthList[index].date == plannedActual.date">
                          <div style="height: 9px">
                            <div v-if="plannedActual.jiagong_plan" class="div" style="background: rgba(255 245 204);border:rgba(255 204 0) solid 1px;"></div>
                            <div v-if="plannedActual.jiagong_plan == null" class="div" style="background: rgba(255 255 255);border:rgba(255 255 255) solid 1px;"></div>
                            <div v-if="plannedActual.jiagong_actual" class="div" style="background: rgba(255 204 0);width: 100%;"></div>
                          </div>
                          <div style="height: 9px">
                            <div v-if="plannedActual.tuzhuang_plan" class="div" style="background: rgba(229 181 255);border:rgba(166 0 255) solid 1px "></div>
                            <div v-if="plannedActual.tuzhuang_plan == null" class="div" style="background: rgba(255 255 255);border:rgba(255 255 255) solid 1px;"></div>
                            <div v-if="plannedActual.tuzhuang_actual" class="div" style="background: rgba(166 0 255);"></div>
                          </div>
                          <div style="height: 9px">
                            <div v-if="plannedActual.zuli_plan" class="div" style="background: #DBFCC9;border: #94D82D solid 1px "></div>
                            <div v-if="plannedActual.zuli_plan == null" class="div" style="background: rgba(255 255 255);border:rgba(255 255 255) solid 1px;"></div>
                            <div v-if="plannedActual.zuli_actual" class="div" style="background: #94D82D"></div>
                          </div>

                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table-column>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="size" style="height: 30%;border:none">
          <div style="width: 100%;height: 100%;">
            <el-form label-width="10px">
              <el-row>
                <!--                <el-button v-if="playShow === true" @click="pauseTimer" icon="el-icon-video-pause" style="font-size: 25px"></el-button>-->
                <!--                <el-button v-if="playShow === false" @click="startTimer" icon="el-icon-video-play" style="font-size: 25px"></el-button>-->
                <div style="width: 45%">
                  <el-date-picker v-model="zuliProductionData.day" format="YYYY 年 M 月" disabled
                                  value-format="YYYY-M-1" type="month" placeholder="选择月份" style="width: 140px"
                                  :clearable="false"/>
                </div>
                <span style="font-size: 20px;font-weight: bold">{{'组立生产实绩'}}</span>
              </el-row>
            </el-form>
            <!-- 生产实绩-->
            <div v-loading="zuliProductionOutputLoading" element-loading-text="数据加载中" style="width: 100%;height: 90%;" id="zuliProductionOutput"/>
            <!--            &lt;!&ndash; 生产性&ndash;&gt;-->
            <!--            <div v-if="showPage === 'productive'" v-loading="zuliProductiveOutputLoading" element-loading-text="数据加载中" style="width: 100%;height: 90%" id="zuliProductiveOutput"/>-->
          </div>
        </div>

      </div>

      <div class="asideContainer" style="border-left: 4px solid whitesmoke;width: 46%" >
        <div class="size"  style="height: 58%">
          <div class="title"><span>{{'物件进度'}}</span></div>
          <div style="width: 100%;height: 90%;">
            <el-table :data="planData.floorData" border :key="tableKey" stripe style="width: 100%;"
                      :header-cell-style="{textAlign: 'center',fontSize:'16px'}"
                      :cell-style="{ textAlign: 'center', width: '100%',fontSize:'15px'}" height="100%">
              <el-table-column prop="floor" label="楼层" min-width="60" fixed/>
              <el-table-column prop="weight" label="重量(KG)" min-width="60">
                <template v-slot="scope">
                  {{scope.row.weight.toLocaleString()}}
                </template>
              </el-table-column>
              <el-table-column prop="unit_num" label="单元数量" min-width="70"/>
              <el-table-column prop="area" label="面积(㎡)" min-width="60">
                <template v-slot="scope">
                  {{scope.row.area.toLocaleString()}}
                </template>
              </el-table-column>
              <el-table-column label="加工进度" min-width="95">
                <template v-slot="scope">
                  <el-progress :text-inside="true" :stroke-width="15" :percentage="scope.row.jg_schedule" :color="customColors" class="yw_left" />
                </template>
              </el-table-column>
              <el-table-column label="涂装进度" min-width="95">
                <template v-slot="scope">
                  <el-progress :text-inside="true" :stroke-width="15" :percentage="scope.row.tz_schedule" :color="customColors" class="yw_left" />
                </template>
              </el-table-column>
              <el-table-column label="组立进度" min-width="95">
                <template v-slot="scope">
                  <el-progress :text-inside="true" :stroke-width="15" :percentage="scope.row.zl_schedule" :color="customColors" class="yw_left" />
                </template>
              </el-table-column>
              <el-table-column label="出荷进度" min-width="95">
                <template v-slot="scope">
                  <el-progress :text-inside="true" :stroke-width="15" :percentage="scope.row.outbound_schedule" :color="customColors" class="yw_left" />
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="size" style="height: 30%;border:none">
          <div style="width: 100%;height: 100%;">
            <el-form label-width="10px">
              <el-row style="width: 100%;">
                <!--                <el-button v-if="playShow === true" @click="pauseTimer" icon="el-icon-video-pause" style="font-size: 25px"></el-button>-->
                <!--                <el-button v-if="playShow === false" @click="startTimer" icon="el-icon-video-play" style="font-size: 25px"></el-button>-->
                <div style="width: 45%">
                  <el-date-picker v-model="zuliProductionData.day" format="YYYY 年 M 月" disabled
                                  value-format="YYYY-M-1" type="month" placeholder="选择月份" style="width: 140px"
                                  :clearable="false"/>
                </div>

                <span style="font-size: 20px;font-weight: bold">{{'组立生产性'}}</span>
              </el-row>
            </el-form>
            <!--            &lt;!&ndash; 生产实绩&ndash;&gt;-->
            <!--            <div v-if="showPage === 'production'" v-loading="zuliProductionOutputLoading" element-loading-text="数据加载中" style="width: 100%;height: 90%;" id="zuliProductionOutput"/>-->
            <!-- 生产性-->
            <div v-loading="zuliProductiveOutputLoading" element-loading-text="数据加载中" style="width: 100%;height: 90%" id="zuliProductiveOutput"/>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  name: "MfgZLSiteWJ",
  props: ['parentData'],
  data(){
    return {
      totalTime:null,
      timerProduction:null,
      timerProductive:null,
      id:'',
      wujian_id: '',
      wujian_short_name:'',
      currentTime: '',
      pieDate: {
        year: this.$common.getCurrentYearByMonth().toString(),
        month: this.$common.getDateLabel(new Date().getUTCMonth() + 1),
        day: this.$common.getDateLabel(new Date().getDate()),
      },
      //物件概要
      wujianInfoData:{},
      //物件计划&实际
      planAchievementsData: {
        wujianId: '',
        startMonth:this.getDateFormat(),
        endMonth:this.getDateFormat(),
        floorData: [],
        floorAllList: [],
        dateList: [],
        planAchievementsIndex: 0, // 当前显示的数据在allData中的起始索引
      },
      intervalId: null, // 存储定时器的ID
      //物件计划
      planData: {
        wujianId: '',
        floorData: [],
        dateList: [],
        floorAllList: [],
        planIndex: 0, // 当前显示的数据在allData中的起始索引
      },
      customColors:[
        { color: '#f56c6c', percentage: 20 },
        { color: '#dcf372', percentage: 40 },
        { color: '#c0f08b', percentage: 60 },
        { color: '#9ce17a', percentage: 80 },
        { color: '#67c23a', percentage: 100 },
      ],
      //物件日生产生产实绩
      zuliProductionData: {
        day: this.getDateFormat(),
        wuJianId:''
      },
      //生产性
      zuliProductiveData: {
        day: this.getDateFormat(),
        wuJianId:''
      },
      showPage:'production',
      playShow:true,
      //物件日生产生产实绩
      zuliProductionOutput: {
        title: [],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          top: '0',
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '10%',
          top:'15%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name:'套数',
            min: 0,
            max: 100,
            interval: 20,
            axisLabel: {
              formatter: function (value) {
                return value.toFixed(0)
              }
            }
          },
          {
            type: 'value',
            name:'累計数',
            min: 0,
            max: 10,
            interval: 0.5,
            axisLabel: {
              formatter: function (value) {
                return value.toFixed(0)
              }
            }
          }
        ],
        series: [
          {
            name: '计划',
            type: 'bar',
            label: {
              show: true,  // 显示标签
              position: 'top',  // 标签位置在柱子顶部
              formatter: function (params) {
                // 如果数值为 0，则不显示标签
                return params.value === 0 ? '' : params.value;
              },
              fontSize: 9  // 设置字体大小
            },
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '实绩',
            type: 'bar',
            label: {
              show: true,  // 显示标签
              position: 'top',  // 标签位置在柱子顶部
              formatter: function (params) {
                // 如果数值为 0，则不显示标签
                return params.value === 0 ? '' : params.value;
              },
              fontSize: 9  // 设置字体大小
            },
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          // {
          //   name: '面积',
          //   type: 'line',
          //   color: '#00ccff',
          //   yAxisIndex: 1,
          //   areaStyle: {
          //     opacity: 0.4
          //   },
          //   tooltip: {
          //     valueFormatter: function (value) {
          //       return value;
          //     }
          //   },
          //   data: []
          // },
          {
            name: '累計計画',
            type: 'line',
            color: '#fac858',
            yAxisIndex: 1,
            label: {
              show: true,  // 显示标签
              position: 'top',  // 标签位置在点顶部
              formatter: function (params) {
                const date = new Date();
                const year = date.getFullYear();
                const month = date.getMonth() + 1;  // 月份从 0 开始，所以需要加 1
                const lastDay = new Date(year, month, 0).getDate();
                return params.dataIndex === lastDay - 1 ? params.value : '';
              },
              fontSize: 9  // 设置字体大小
            },
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '累計実績',
            type: 'line',
            color: '#ee6666',
            yAxisIndex: 1,
            label: {
              show: true,  // 显示标签
              position: 'top',  // 标签位置在点顶部
              formatter: function (params) {
                const date = new Date();
                const year = date.getFullYear();
                const month = date.getMonth() + 1;  // 月份从 0 开始，所以需要加 1
                const lastDay = new Date(year, month, 0).getDate();
                return params.dataIndex === lastDay - 1 ? params.value : '';
              },
              fontSize: 9  // 设置字体大小
            },
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      zuliProductionOutputLoading:false,
      //物件日生产性
      zuliProductiveOutput: {
        title: [],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          top: '0',
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '10%',
          top:'15%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name:'面积(㎡)',
            min:0,
            max:100,
            interval:20,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(0)
              }
            }
          },
          {
            type: 'value',
            name: '生产性',
            min:0,
            max:10,
            interval:0.5,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(1)
              }
            }
          }
        ],
        series: [
          // {
          //   name: '产量套数',
          //   type: 'bar',
          //   tooltip: {
          //     valueFormatter: function (value) {
          //       return value;
          //     }
          //   },
          //   data: []
          // },
          {
            name: '工数',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '面积',
            type: 'line',
            connectNulls: true,  // 连接空数据点
            label: {
              show: true,  // 显示标签
              position: 'top',  // 标签位置在柱子顶部
              formatter: function (params) {
                // 如果数值为 0，则不显示标签
                return params.value === 0 ? '' : params.value;
              },
              fontSize: 9  // 设置字体大小
            },
            color: '#00ccff',
            areaStyle: {
              opacity : 0.4
            },
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '目标生产性',
            type: 'line',
            color:'#fac858',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '実績生産性',
            type: 'line',
            color:'#ee6666',
            yAxisIndex: 1,
            connectNulls: true,  // 连接空数据点
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '累计生産性',
            color:'#9932CD',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      zuliProductiveOutputLoading: false,
    }
  },
  methods: {
    getDateFormat(){
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },
    renderEcharts(id,option){
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
        /*let time
        let _this = this
        //chart绑定滚动事件
        chart.on('dataZoom',function (params) {
          //滚动条事件添加防抖
          clearTimeout(time)
          time = setTimeout(()=>{
            _this.getWuJianChartData(params)
          },1000)
        })*/
      }
    },
    async getWuJianShortName() {
      let {data: res} = await this.$axios.post('bus/datasource/getWuJianData',this.wujian_id);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      this.wujian_short_name = res.data.wujian_short_name
      this.wujianInfoData = res.data
    },
    //物件计划&实际
    getPlanAchievementsData(){
      this.planAchievementsData.wujianId = this.wujian_id
      this.$axios.post('mfg/planAchievements/getPlanAchievementsData',this.planAchievementsData).then(response => {
        let res = response.data
        if (res.code === 0) {
          this.planAchievementsData.dateList = res.data.dateList
          this.planAchievementsData.floorAllList = res.data.floorData
          //初始4条
          this.planAchievementsData.floorData = this.planAchievementsData.floorAllList.slice(this.planAchievementsData.planAchievementsIndex, this.planAchievementsData.planAchievementsIndex + 4);
          this.planAchievementsData.planAchievementsIndex = 4;
          if (this.planAchievementsData.planAchievementsIndex >= this.planAchievementsData.floorAllList.length) {
            this.planAchievementsData.planAchievementsIndex = 0;
          }
        }
      }, error => {
        this.$message.error(`获取数据失败` + error.message);
      })
    },

    //每过10秒切换4条
    startDataRefresh() {
      this.stopDataRefresh(); // 确保只有一个定时器运行
      this.intervalId = setInterval(() => {
        this.planAchievementsData.floorData = this.planAchievementsData.floorAllList.slice(this.planAchievementsData.planAchievementsIndex, this.planAchievementsData.planAchievementsIndex + 4);
        this.planAchievementsData.planAchievementsIndex += 4;
        if (this.planAchievementsData.planAchievementsIndex >= this.planAchievementsData.floorAllList.length) {
          this.planAchievementsData.planAchievementsIndex = 0; // 循环到数据末尾时重置索引
        }

        // this.planData.floorData = this.planData.floorAllList.slice(this.planData.planIndex, this.planData.planIndex + 20);
        // this.planData.planIndex += 20;
        // if (this.planData.planIndex >= this.planData.floorAllList.length) {
        //   this.planData.planIndex = 0; // 循环到数据末尾时重置索引
        // }
      }, 10000); // 每10秒更新一次
    },
    stopDataRefresh() {
      clearInterval(this.intervalId);
    },
    //物件计划
    getPlanData(){
      this.planData.wujianId = this.wujian_id
      this.$axios.post('mfg/wuJianInfo/getWujianScheduling',this.planData).then(response => {
        let res = response.data
        if (res.code === 0) {
          this.planData.floorAllList = res.data.schedulingDataList
          //初始13条
          this.planData.floorData = this.planData.floorAllList.slice(this.planData.planIndex, this.planData.planIndex + 18);
          this.planData.planIndex = 18;
          if (this.planData.planIndex >= this.planData.floorAllList.length) {
            this.planData.planIndex = 0;
          }
          this.planAchievementsLoading = false;

        }
      }, error => {
        this.$message.error(`获取数据失败` + error.message);
      })
    },
    //开始轮播
    startTimer(){
      this.playShow = true
      this.timerProductive = setInterval(() => {
        this.showPage = "productive"
        this.getDayProductiveOutput()
        this.timerProduction = setTimeout(() =>{
          this.showPage = "production"
          this.getZuliProduction()
        },30000)
      },60000)
    },
    // 暂停轮播
    pauseTimer(){
      this.playShow = false
      clearInterval(this.timerProduction)
      clearInterval(this.timerProductive)
    },
    //生产实绩
    async getZuliProduction(){

      this.zuliProductionOutputLoading = true
      this.zuliProductionData.wuJianId = this.wujian_id
      let {data: res} = await this.$axios.post('mfg/zuliActualProduction/getZuliProduction',this.zuliProductionData);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        this.zuliProductionOutput.xAxis[0].data = res.data.xAxis
        this.zuliProductionOutput.series[0].data = res.data.planList
        this.zuliProductionOutput.series[1].data = res.data.actualList
       // this.zuliProductionOutput.series[2].data = res.data.areaList
        this.zuliProductionOutput.series[2].data = res.data.accumulatePlanList
        this.zuliProductionOutput.series[3].data = res.data.accumulateActualList

        let maxA = this.$common.getMaxValue(res.data.planList,res.data.actualList)
        let maxB = this.$common.getMaxValue(res.data.accumulatePlanList,res.data.accumulateActualList)

        this.zuliProductionOutput.yAxis[0].max = Math.ceil(maxA/5)*6
        this.zuliProductionOutput.yAxis[0].interval = Math.round(this.zuliProductionOutput.yAxis[0].max / 5 * 100) / 100

        this.zuliProductionOutput.yAxis[1].max = Math.ceil(maxB/5)*6
        this.zuliProductionOutput.yAxis[1].interval = Math.round(this.zuliProductionOutput.yAxis[1].max / 5 * 100) / 100
      }
      this.renderEcharts('zuliProductionOutput',this.zuliProductionOutput)
      this.zuliProductionOutputLoading = false
    },
    //物件生产性
    async getDayProductiveOutput() {
      this.zuliProductiveOutputLoading = true
      this.zuliProductiveData.wuJianId = this.wujian_id
      let {data: res} = await this.$axios.post('mfg/zuliProductive/getzuliProductive',this.zuliProductiveData);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        this.zuliProductiveOutput.xAxis[0].data = res.data.xAxis
        //this.zuliProductiveOutput.series[0].data = res.data.produceNum
        this.zuliProductiveOutput.series[0].data = res.data.produceArtificial
        this.zuliProductiveOutput.series[1].data = res.data.produceArea
        this.zuliProductiveOutput.series[2].data = res.data.expectedProductivity
        this.zuliProductiveOutput.series[3].data = res.data.actualProductivity
        this.zuliProductiveOutput.series[4].data = res.data.accumulateProductivity

        let maxA = this.$common.getMaxValue(res.data.produceArtificial,res.data.produceArea)
        let maxB = this.$common.getMaxValue1(res.data.expectedProductivity,res.data.actualProductivity,res.data.accumulateProductivity)

        this.zuliProductiveOutput.yAxis[0].max = Math.ceil(maxA/5)*6
        this.zuliProductiveOutput.yAxis[0].interval = Math.round(this.zuliProductiveOutput.yAxis[0].max / 5 * 100) / 100

        this.zuliProductiveOutput.yAxis[1].max = Math.ceil(maxB/5)*6
        this.zuliProductiveOutput.yAxis[1].interval = Math.round(this.zuliProductiveOutput.yAxis[1].max / 5 * 100) / 100
      }
      this.renderEcharts('zuliProductiveOutput',this.zuliProductiveOutput)

      this.zuliProductiveOutputLoading = false
    },

  },

  created() {
    this.wujian_id = this.parentData
    this.getWuJianShortName()
    this.getPlanAchievementsData()
    this.getPlanData()
    this.getZuliProduction()
    this.getDayProductiveOutput()
    this.startDataRefresh();
  },

  mounted(){
    // //生产实际和生产性轮播 30秒
    // this.timerProductive = setInterval(() => {
    //   this.showPage = "productive"
    //   this.getDayProductiveOutput()
    //   this.timerProduction = setTimeout(() =>{
    //     this.showPage = "production"
    //     this.getZuliProduction()
    //   },30000)
    // },60000)
    //页面所有数据刷新  30分钟
    this.totalTime = setInterval(()=>{
      this.getWuJianShortName()
      this.getPlanAchievementsData()
      this.getPlanData()
    }, 1800000)
  },

  unmounted() {
    clearInterval(this.totalTime)
    clearInterval(this.timer)
    // clearInterval(this.timerProduction)
    // clearInterval(this.timerProductive)
    this.stopDataRefresh();
  }

}
</script>

<style scoped>

.pageContainer{
  display: flex;
  flex-direction: row;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.asideContainer{
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content:  flex-start;
  align-items: center;
}

.size{
  height: 40%;
  justify-content: center;
}

.title{
  border-left: 3px solid steelblue;
  height: 18px;
  width: 90%;
  font-size: 18px;
  padding-left: 5px;
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

margin-right{
  margin-right: 5px;
}

.dotClass {
  width: 12px;
  height: 12px;
  border: black;
  display: block;
  margin-left: 10px;
}

.div {
  width: 100%;
  height: 4px;
  margin-top: 1px;
}

.el-table :deep(.cell) {
  padding: 0px;
}

.el-table :deep(.el-table__cell) {
  padding: 0px;
}
.yw_left >>>  .el-progress-bar__innerText {
  color: black;
}
</style>